import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { AuthShell } from "@/components/AuthShell";
import { Field, FormAlert, PasswordInput, PrimaryButton, inputCls } from "@/components/FormBits";
import { useAuth } from "@/context/AuthContext";
import { formatApiError, maskPhone, phoneDigits } from "@/lib/api";

export default function AdminLogin() {
  const { adminLogin, user } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (phoneDigits(phone).length < 10 || !password) {
      setError("Digite o celular administrativo e a senha.");
      return;
    }
    setLoading(true);
    try {
      await adminLogin(phoneDigits(phone), password);
      navigate("/admin", { replace: true });
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setLoading(false);
    }
  };

  if (user?.role === "admin") {
    return (
      <AuthShell testId="admin-login-page" title="Acesso ADM" subtitle="Você já está autenticado como administrador.">
        <Link data-testid="admin-login-go-dashboard" to="/admin" className="flex min-h-[56px] items-center justify-center rounded-xl bg-emerald-700 px-5 text-lg font-bold text-white hover:bg-emerald-800">Ir para o painel ADM</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell testId="admin-login-page" title="Acesso ADM" subtitle="Área exclusiva do administrador geral.">
      <div className="mb-6 flex gap-3 rounded-2xl border-2 border-amber-200 bg-amber-50 p-4 text-amber-950">
        <ShieldCheck className="mt-0.5 h-6 w-6 shrink-0" />
        <p className="font-semibold">Use apenas as credenciais administrativas da plataforma.</p>
      </div>
      <form onSubmit={submit} noValidate className="space-y-6" data-testid="admin-login-form">
        <Field id="admin-login-phone" label="Celular administrativo">
          <input id="admin-login-phone" data-testid="admin-login-phone-input" className={inputCls} value={phone} onChange={(event) => setPhone(maskPhone(event.target.value))} inputMode="numeric" autoComplete="tel" placeholder="(11) 98765-4321" />
        </Field>
        <Field id="admin-login-password" label="Senha administrativa">
          <PasswordInput id="admin-login-password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" />
        </Field>
        <FormAlert testId="admin-login-error">{error}</FormAlert>
        <PrimaryButton type="submit" loading={loading} data-testid="admin-login-submit-button">Entrar no ADM</PrimaryButton>
      </form>
    </AuthShell>
  );
}